import { render, staticRenderFns } from "./MessageLoadingSkeleton.vue?vue&type=template&id=3e38ab00&scoped=true"
import script from "./MessageLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./MessageLoadingSkeleton.vue?vue&type=script&lang=js"
import style0 from "./MessageLoadingSkeleton.vue?vue&type=style&index=0&id=3e38ab00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38ab00",
  null
  
)

export default component.exports